import { useState } from "react";

const useListFilters = () => {
    const [search, _setSearch] = useState();
    const [loading, setLoading] = useState(true);
    const [tableParams, setTableParams] = useState({
        pagination: {
            current: 1,
            pageSize: 10,
        },
    });

    const setSearch =(text) => {
        setTableParams({
            pagination: {
                current: 1,
                pageSize: 10,
            },
        });
        _setSearch(text)
    }

    return {
        search,
        loading,
        tableParams,
        setSearch,
        setLoading,
        setTableParams,
    }
}

export default useListFilters